import { ComponentDataDestService } from '../component-data-dest.service';
import { catchError, map, tap } from 'rxjs';
import { LocationDTO } from '../../../dto/location/location.dto';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { environment } from '../../../environment/environment';
import { notifyDunaLocationsAdminFormSuccess, refreshAllLocationTableStores } from './location-stores-refresh';

function parseOptionalCoordinate(value: unknown): number | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const num = typeof value === 'number' ? value : parseFloat(String(value));
  return Number.isFinite(num) ? num : null;
}

export function add_location(
  componentDataDestService: ComponentDataDestService,
  componentDataSourceService: ComponentDataSourceService,
  data: any
) {
  const locationDTO: LocationDTO = {
    guid: data.guid || '',
    locations_name: data.locations_name,
    clean_name: data.clean_name,
    latitude: parseOptionalCoordinate(data.latitude),
    longitude: parseOptionalCoordinate(data.longitude),
    data: {
      locations_address: data.locations_address
    },
    rooms: [],
    users: [],
    registered_percentage: 0,
    progress_percentage: 0,
    ok_percentage: 0,
    firefighter_count: 0
  };

  const request$ = componentDataDestService.http
    .post(`${environment.apiUrl}/locations`, { location: locationDTO })
    .pipe(
      catchError((error) => {
        console.error('[add_location] Error:', error);
        throw error;
      }),
      map((response) => response)
    );

  return componentDataSourceService.updateStoreData(request$, 'locations').pipe(
    tap(() => {
      refreshAllLocationTableStores(componentDataSourceService);
      notifyDunaLocationsAdminFormSuccess();
    })
  );
}
